/**
 * @author laci
 */
import ajaxConfig from './ajax-config';
import promisedRequestFactory from './promised-request';

export default function (app) {
	app.factory('ajax', ['$http', '$q', '$cookies', function ($http, $q, $cookies) {
		$http.defaults.headers.common["XSRF-TOKEN"] = $cookies.get('XSRF-TOKEN');

		return {
			promisedRequest: promisedRequestFactory($http),
			inLoopPromises: function (endPoint, params) {
				var promises = [];
				angular.forEach(params.items, function (item) {
					var data = {
						body: item.body || item,
						urlParameters: item.urlParameters || params.urlParameters || {},
						query: item.query || {}
					};
					promises.push(promisedRequestFactory($http)(endPoint, data));
				});
				return $q.all(promises);
			},
			parallelRequest: function (requests) {
				return $q.all(requests);
			}
		};
	}]);
	ajaxConfig(app);
};
